import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

const REMINDER_ID = 1001;
const STORAGE_KEY_ENABLED = 'sv_reminder_enabled';
const STORAGE_KEY_TIME = 'sv_reminder_time';

function getReminderBody(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Take a moment to check in with your body.';
  if (hour >= 18) return 'End your day with a quick SeeVita scan.';
  return 'Time for your wellness scan.';
}

export function getReminderSettings(): { enabled: boolean; time: string } {
  return {
    enabled: localStorage.getItem(STORAGE_KEY_ENABLED) === 'true',
    time: localStorage.getItem(STORAGE_KEY_TIME) ?? '08:00',
  };
}

export async function requestPermission(): Promise<'granted' | 'denied'> {
  if (!Capacitor.isNativePlatform()) return 'denied';
  const result = await LocalNotifications.requestPermissions();
  return result.display === 'granted' ? 'granted' : 'denied';
}

export async function scheduleReminder(time: string): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  const [hourStr, minuteStr] = time.split(':');
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  // Cancel any existing reminder first
  await LocalNotifications.cancel({ notifications: [{ id: REMINDER_ID }] }).catch(() => {});

  const at = new Date();
  at.setHours(hour, minute, 0, 0);
  if (at <= new Date()) at.setDate(at.getDate() + 1);

  await LocalNotifications.schedule({
    notifications: [{
      id: REMINDER_ID,
      title: 'SeeVita',
      body: getReminderBody(hour),
      schedule: { at, every: 'day', allowWhileIdle: true },
      actionTypeId: '',
      extra: null,
    }],
  });

  localStorage.setItem(STORAGE_KEY_ENABLED, 'true');
  localStorage.setItem(STORAGE_KEY_TIME, time);
}

export async function cancelReminder(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await LocalNotifications.cancel({ notifications: [{ id: REMINDER_ID }] }).catch(() => {});
  }
  localStorage.setItem(STORAGE_KEY_ENABLED, 'false');
}
